(function(){

var repo = createRepo();

//.............................................................................

				//module: ./common/utils
(function(define){
define([], () => {
    return {
        setCookie,
        getCookie,
        removeCookie,
        makeXHRAjaxRequest,
        getOCDNUrl,
        makeUrl,
        popup,
    };

    // Cookie management
    function setCookie(cookieName, value, exdays, path) {
        let exdate = new Date(); let
            expires;
        let cPath = path ? `;path=${path}` : '';

        if (exdays === 0) {
            expires = 0;
        } else {
            exdate.setDate(exdate.getDate() + exdays);
            expires = exdate.toUTCString();
        }

        document.cookie = cookieName + "=" + escape(value) + cPath + ((exdays === null) ? "" : "; expires="+expires);
    }

    function getCookie(cookieName) {
        let i; let x; let y; let
            ARRcookies = document.cookie.split(';');

        if (ARRcookies && ARRcookies.length) {
            for (i = 0; i < ARRcookies.length; i++) {
                x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
                y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
                x = x.replace(/^\s+|\s+$/g, '');

                if (x === cookieName) {
                    return unescape(y);
                }
            }
        }

        return null;
    }

    function removeCookie(cookieName) {
        document.cookie = `${cookieName}=; Max-Age=-99999999;`;
    }

    // Ajax call
    function makeXHRAjaxRequest(method, url, queryParams = '', done) {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url.concat('?', queryParams));

        xhr.onload = () => {
            done(null, xhr.response);
        };

        xhr.onerror = () => {
            done(xhr.response);
        };

        xhr.send();
    }

    // OCDN management
    function getOCDNUrl() {
        const styleSheets = document.querySelectorAll('[rel="stylesheet"]');

        for (let property in styleSheets) {
            if (styleSheets.hasOwnProperty(property)) {
                console.log(styleSheets.hasOwnProperty(property).href);
            }
        }
    }

    function makeUrl(baseUrl, params) {
        let out = [];

        for (let prop in params) {
            out.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`);
        }

        if (out.length > 0) {
            if (baseUrl.indexOf('?') >= 0) {
                return `${baseUrl}&${out.join('&')}`;
            }

            return `${baseUrl}?${out.join('&')}`;
        }

        return baseUrl;
    }

    function popup(url, name, width, height) {
        let options = [
            ['width', width],
            ['height', height],
            ['scrollbars', '1'],
            ['scrollbars', 'yes'],
            ['toolbar', '0'],
            ['status', '0']
        ];

        let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
        let dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;

        // pobranie wymiarów zewnętrznych okna przeglądarki

        let outerWidth = window.outerWidth
            ? window.outerWidth
            : document.documentElement && document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : null;

        let outerHeight = window.outerHeight
            ? window.outerHeight
            : document.documentElement && document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : null;

        if (outerWidth !== null) {
            options.push(['left', Math.floor((outerWidth - width) / 2) + dualScreenLeft]);
        }

        if (outerHeight !== null) {
            options.push(['top', Math.floor((outerHeight - height) / 2) + dualScreenTop]);
        }

        window.open(url, name, optionsToString(options));

        function optionsToString(options) {
            let out = [];

            for (let i = 0; i < options.length; i++) {
                out.push(options[i].join('='));
            }

            return out.join(', ');
        }
    }
});

}(repo.getDefine("./common", "utils")));

//.............................................................................

				//module: ./common/socialShare
(function(define){
define(['./utils'], utils => {
    return {
        twitter,
        facebook,
        copyLink,
        showShareButtons,
    };

    /**
     * Option to copy the link of the current address.
     * @param {object} domElement
     */
    function copyLink(domElement) {
        domElement.addEventListener('click',(e) => {
            const reloadIconTime = 6000; //sec
            const url = e.target.getAttribute('data-share-link');
            const note = e.target.getAttribute('data-share-note');
            navigator.clipboard.writeText(url)
                .then(() => {
                    const span = document.createElement('span');
                    span.classList.add('copy-active');
                    span.innerHTML = note;
                    const spanElement = e.target.appendChild(span);
                    e.target.classList.add('socialShare-button-active');

                    setTimeout(() => {
                        spanElement.remove();
                        e.target.classList.remove('socialShare-button-active');
                    }, reloadIconTime);
                });
        });
    }

    function facebook(domElement) {
        domElement.addEventListener('click', e => {
            const utmTags = getDataTags(domElement, 'extrautm');
            const shareURL = utmTags ? (window.location + '').split('?').shift() + '?' + utmTags : window.location;
            let urlOpen = utils.makeUrl('https://www.facebook.com/sharer/sharer.php', {
                u: shareURL,
            });
            utils.popup(urlOpen, 'share_window', 600, 600);
        });
    }

    function twitter(domElement) {
        // eslint-disable-next-line no-unused-vars
        domElement.addEventListener('click', e => {
            const utmTags = getDataTags(domElement, 'extrautm');
            const shareURL = utmTags ? (window.location + '').split('?').shift() + '?' + utmTags : window.location;
            const shareTitle = getOGTagFromMeta('twitter:title', getOGTagFromMeta('og:title', ''), 'name');
            const shareVia = getOGTagFromMeta('twitter:site', getDataTags(domElement, 'socialname'), 'name').replace(/\s/g, '');
            let params = {
                url: shareURL,
                text: shareTitle,
                original_referer: shareVia, // prawdopodobnie nieużywany parametr
            };

            if (typeof (shareVia) === 'string' && shareVia !== '') {
                params.via = shareVia;
            }

            let urlOpen = utils.makeUrl('https://twitter.com/intent/tweet', params);

            utils.popup(urlOpen, 'share_window', 550, 480);
        });
    }

    function getDataTags(domElement, dataName) {
        let dataTags = domElement.getAttribute(`data-${dataName}`);

        if (dataTags && dataTags.indexOf('#host')) {
            const hostName = window.location.host.replace('www.', '').split('.').shift();
            dataTags = dataTags.replace('#host', hostName);
        }

        return dataTags;
    }

    function getOGTagFromMeta(name, defaultValue, attrName) {
        attrName = attrName || 'property';
        const list = document.querySelectorAll(`meta[${attrName}="${name}"]`);

        if (list.length > 0) {
            return list[0].getAttribute('content');
        }

        return defaultValue;
    }

    /**
     * Show more share buttons. One Button share options.
     * @returns {void} - not return value
     */
    function showShareButtons(domElement) {
        // eslint-disable-next-line no-unused-vars
        domElement.addEventListener('click', e => {
            const isVertical = domElement.getAttribute('data-vertical') === 'true';
            const shareIconBox = document.querySelector('.shareIcon-box');

            domElement.classList.toggle('active-share-button');
            const shareArea = document.querySelector('.ring-detail-social-share');

            if (!shareArea) {
                return;
            }

            const buttons = shareArea.querySelectorAll('.more-icon');

            for (const button of buttons) {
                const isHidden = button.classList.contains('hidden-icon');

                if (isHidden) {
                    button.classList.remove('hidden-icon');

                    if (isVertical) {
                        button.classList.add('vertical-icon');
                    }

                    continue;
                }

                button.classList.add('hidden-icon');

                if (isVertical) {
                    button.classList.remove('vertical-icon');
                }
            }


            if (shareIconBox) {
                let positionIcon = 'vertical bottom';

                if (shareIconBox.hasAttribute('data-position-icon')) {
                    positionIcon = shareIconBox.getAttribute('data-position-icon');
                }

                if (positionIcon === 'vertical top') {
                    const correctHeight = 60;
                    const offsetHeightShareIconBox = parseInt(shareIconBox.offsetHeight) + correctHeight;
                    shareIconBox.style.marginTop = `-${offsetHeightShareIconBox}px`;
                }
            }
        });
    }
});

}(repo.getDefine("./common", "socialShare")));

//.............................................................................

				//module: ./socialShare
(function(define){
define([
    './common/socialShare',
], (
    socialShare,
// eslint-disable-next-line max-params
) => ({
    facebook: socialShare.facebook,
    twitter: socialShare.twitter,
    link: socialShare.copyLink,
    showShareButtons: socialShare.showShareButtons,
}));

}(repo.getDefine(".", "socialShare")));

//.............................................................................

repo.install("./socialShare");

//.............................................................................

function createRepo() {

    var isInstall = false;
    //moduły zewnętrzne
    var modulesExt = createModulesExt();
    //moduły lokalne
    var modules = {};

    return {
        getDefine: getDefine,
        install: install
    };

    function getDefine(path, name) {

        return function(deps, def) {

            if (isInstall === false) {

                modules[path + '/' + name] = createEvalModule(path, deps, def);

            } else {

                throw Error('You cannot define module after configuration process');
            }
        };
    }

    function createEvalModule(path, deps, def) {

        var moduleObject = null;

        addToExt(deps);

        return {
            'get': get
        };

        function get(extModuleObj) {

            if (moduleObject === null) {
                moduleObject = createModuleObject(extModuleObj);
            }

            return moduleObject;
        }

        function createModuleObject(extModuleObj) {

            var depsResolve = [];

            for (var i = 0; i < deps.length; i++) {
                depsResolve.push(resolve(deps[i]));
            }

            return def.apply(null, depsResolve);

            function resolve(moduleName) {

                if (isModuleLocal(moduleName)) {

                    return getLocal(moduleName);

                } else {

                    return getExtends(moduleName);
                }
            }

            function getExtends(moduleName) {

                if (moduleName in extModuleObj) {
                    return extModuleObj[moduleName];
                } else {
                    throw Error('There is no definition for external module: ' + moduleName);
                }
            }

            function getLocal(moduleName) {

                var modulePath = path + '/' + moduleName;
                var out;

                var modulePathNormalize = normalizePath(modulePath);

                if (typeof(modulePathNormalize) === 'string' && modulePathNormalize !== '') {

                    out = getFromModules(modulePathNormalize);

                    if (out !== null) {
                        return out;
                    } else {
                        throw Error('There is no definition for module: ' + modulePathNormalize);
                    }

                } else {

                    throw Error('There is a problem with path normalization: ' + modulePath);
                }

                function getFromModules(moduleFullName) {

                    var value = modules[moduleFullName];

                    if (typeof(value) !== 'undefined') {
                        return value.get(extModuleObj);
                    } else {
                        return null;
                    }
                }
            }
        }
    }

    function normalizePath(path) {

        var chunks = path.split('/');

        var newChunks = [];

        for (var i = 0; i < chunks.length; i++) {

            var value = chunks[i];

            if (value === '.') {

                if (newChunks.length === 0) {

                    newChunks.push(value);

                } else {

                    //ignoruj znak
                }

            } else if (value === '..') {

                if (newChunks.length >= 2) {

                    newChunks.pop();

                } else {

                    return null;
                }

            } else {

                newChunks.push(value);
            }
        }

        return newChunks.join('/');
    }

    function addToExt(deps) {

        for (var i = 0; i < deps.length; i++) {
            add(deps[i]);
        }

        function add(moduleName) {

            if (isModuleLocal(moduleName)) {

            } else {

                modulesExt.addName(moduleName);
            }
        }
    }

    function isModuleLocal(moduleName) {

        if (typeof(moduleName) === 'string') {

            if (moduleName.length >= 2 && moduleName.substr(0, 2) === './') {
                return true;
            } else if (moduleName.length >= 3 && moduleName.substr(0, 3) === '../') {
                return true;
            } else {
                return false;
            }

        } else {

            throw Error('Module name should be string');
        }
    }

    function getModule(name, extModuleObj) {

        if (typeof(modules[name]) !== 'undefined') {
            return modules[name].get(extModuleObj);
        } else {
            throw Error('Module not defined: ' + name);
        }
    }

    //instalowanie zewnętrznej końcówki odnoszącej się do requirejs (która pobierze zewnętrzne moduły)
    function install(mainModule) {

        if (isInstall === false) {

            isInstall = true;

            define(modulesExt.getModulesName(), function() {

                //konwersja "arguments" na tablicę
                var copyParams = Array.prototype.slice.call(arguments, 0);

                //potrzebne do evaluowania ...
                var moduleObj = modulesExt.getExtendsModulesObject(copyParams);

                //ewaluowanie głównego modułu - z podmodułami jeśli trzeba
                return getModule(mainModule, moduleObj);
            });

        } else {

            throw Error('Unsupported state');
        }
    }

    function createModulesExt() {

        var isSet = false;

        var modulesName = [];
        var modulesExtValue = {};

        return {
            'addName': addName,
            'getExtendsModulesObject': getExtendsModulesObject,
            'getModulesName': getModulesName
        };

        function getExtendsModulesObject(modules) {

            if (modulesName.length === modules.length) {

                return getObj();

            } else {

                throw Error('Unsupported state');
            }

            function getObj() {

                var out = {};

                for (var i = 0; i < modulesName.length; i++) {
                    setOut(modulesName[i], modules[i]);
                }

                return out;

                function setOut(name, value) {
                    out[name] = value;
                }
            }
        }

        function getModulesName() {

            return modulesName;
        }

        function addName(name) {

            if (isSet === false) {

                if (isNoEmptyString(name)) {

                    if (typeof(modulesExtValue[name]) !== 'string') {

                        modulesExtValue[name] = name;
                        modulesName.push(name);
                    }

                } else {

                    throw Error('Unsupported parameter type');
                }

            } else {

                throw Error('Unsupported state');
            }
        }
    }

    function isNoEmptyString(value) {

        return (typeof(value) === 'string' && value !== '');
    }
}


//.............................................................................

}());